import { useEffect } from 'react';

import { useAppDispatch } from 'components/shared/App';
import useUrlBooleanFlags from 'hooks/useUrlBooleanFlags';
import { setFlags } from 'store/slices/query';

export type CompaniesPageHook = (value: string) => void;

export default function useCompaniesPage(): CompaniesPageHook {
  const dispatch = useAppDispatch();

  const {
    values: { completedSetup },
    toggleValue,
  } = useUrlBooleanFlags(['completedSetup']);

  useEffect(() => {
    dispatch(
      setFlags([
        'companies',
        {
          completedSetup,
        },
      ]),
    );
  }, [completedSetup]);

  return toggleValue;
}
